import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

const MinimapHint = ({ hintText }) => (
  <Box className="leaflet-bottom leaflet-right">
    <Flex
      className="leaflet-control"
      direction="column"
      bg="blackAlpha.600"
      color="white"
      fontWeight="semibold"
      px="2"
      py="1"
    >
      <Text fontSize="sm" borderRadius="md">
        {hintText}
      </Text>
    </Flex>
  </Box>
);

export default MinimapHint;
